module.exports = __webpack_public_path__ + "img/icon-illustration-coupon-shipping.d517185f.svg";